module.exports = __webpack_public_path__ + "assets/f1e1ebe26537e7d9843cb89e52ed85a1.png";